import {ChangeDetectionStrategy, Component} from '@angular/core';
import {IconComponent} from '../icon/icon.component';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'ucs-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent, TranslatePipe]
})
export class ForbiddenComponent {
}

